export const SET_SEARCH_RESULT = 'set_search_result';
export const CLEAR_SEARCH_RESULT = 'clear_search_result';
export const SEARCH_ACTION = 'search_action';